import React, { useState } from 'react';
import { Box, Typography, Chip, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const KEY = 'repsit-beta-ribbon-dismissed';

/**
 * Beta ribbon under the top bar — the tester's reminder that this is a beta and that feedback
 * matters. Dismissible once per browser session (⚑ D-UI-02, UI review 2026-09-21): a permanent
 * 40–60 px band on every screen became wallpaper that pushed content down; the BETA chip beside
 * the REPSit wordmark keeps the status visible at all times. The three actions (Getting Started ·
 * Help & Docs · Tell the Build Team) live in the page header (`HeaderActions.jsx`, P6-01/P6-10).
 */
export default function BetaBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(KEY) === '1'; } catch { return false; }
  });
  if (dismissed) return null;
  const dismiss = () => {
    setDismissed(true);
    try { sessionStorage.setItem(KEY, '1'); } catch { /* fine */ }
  };
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        pl: 2,
        pr: 1,
        py: 0.5,
        bgcolor: 'brand.band', // Deep Indigo band (P6-13)
        color: 'brand.onBand',
        flexWrap: 'wrap',
        rowGap: 0.5,
      }}
      data-tour="beta-banner"
    >
      <Chip
        label="BETA"
        size="small"
        sx={{ bgcolor: 'rgba(255,255,255,0.22)', color: 'inherit', fontWeight: 700, letterSpacing: 1 }}
      />
      <Typography variant="body2" sx={{ flex: '1 1 220px', minWidth: 0, display: { xs: 'none', sm: 'block' } }}>
        You are one of the first to use REPSit.ai. Your feedback will help make your Intelligent
        Assistant as helpful and knowledgeable as possible.
      </Typography>
      <Typography variant="body2" sx={{ flex: '1 1 160px', minWidth: 0, display: { xs: 'block', sm: 'none' } }}>
        You are one of the first to use REPSit.ai — your feedback shapes it.
      </Typography>
      <IconButton size="small" onClick={dismiss} aria-label="Hide beta ribbon for this session" sx={{ color: 'inherit', ml: 'auto' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
